import gql from 'graphql-tag';

import desktopAppClientFragment from './desktopAppClientFragment';

export const credentialDesktopFragment = gql`
  fragment credentialDesktopFragment on CredentialDesktop {
    dokkioClass
    id
    accountID
    desktopAppClient {
      ...desktopAppClientFragment
    }
  }

  ${desktopAppClientFragment}
`;
export default credentialDesktopFragment;
